// Generated types for MBSE_Action
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from '../../sysml/types/sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from '../../sysml/types/sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_ActionReadAPI extends SysMLElementReadAPI {
  category?: string | null;
}

export interface MBSE_ActionWriteAPI extends SysMLElementWriteAPI {
  category?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_ActionReadAPISchema: z.ZodType<MBSE_ActionReadAPI> = SysMLElementReadAPISchemaObject.extend({
  category: z.string().nullable().optional(),
}).passthrough();

export const MBSE_ActionWriteAPISchema: z.ZodType<MBSE_ActionWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  category: z.string().nullable().optional(),
}).passthrough();
